import { useLazyFetchV2 } from "hooks/fetch/useLazyFetchV2";

/**
 * Provides a callback function which can be used to post to the url passed in
 * @param url the url to post to
 * @returns {{putCallback: ((function(*=, *=): Promise<*>)), loading: boolean, error: boolean}}
 *
 * loading - true when post is currently happening.
 *
 * error - true when an error has occured.
 *
 * putCallback - the put callback function, takes a body object and returns a promise which will contain json from the response.
 */
export function useFetchPutV2(url) {
  const { loading, error, fetchCallback } = useLazyFetchV2("PUT");

  return {
    loading,
    error,
    putCallback: (body, headers = { "Content-Type": "application/json" }) =>
      fetchCallback(url, body, headers)
  };
}
